import { t } from '@lingui/core/macro';
import { Chip, Sidebar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DocumentStatusChip } from 'app/domains/documents';
import { DocumentIdChip } from './DocumentIdChip';
import { useDocumentMetadata } from './DocumentMetadataProvider';
import { CompanyMetadataConfig } from './DocumentMetadataProvider/useGetDocumentMetadata/config';
import { DocumentNameChip } from './DocumentNameChip';
import { TemplateCategory } from './TemplateCategory';
export function SystemMetadataList() {
    const { data, documentId } = useDocumentMetadata();
    const { systemData } = data;
    const { createdAt, createdBy, templateName, updatedAt, status, type, dateSigned } = systemData;
    return (<Sidebar.Section id="system-metadata" title={t({ message: 'Document details', comment: 'Metadata section title' })}>
      <Sidebar.DefinitionList>
        <DocumentIdChip id={documentId}/>

        <DocumentNameChip />

        <Sidebar.DefinitionItem term={t({
            message: 'Document Status',
            comment: 'Metadata sidebar: Label for document status',
        })}>
          <Sidebar.Definition>
            <DocumentStatusChip documentId={documentId} status={status} type={type} size="small" icon={<Falcon icon="plus"/>} secondary={dateSigned}/>
          </Sidebar.Definition>
        </Sidebar.DefinitionItem>

        {templateName && (<Sidebar.DefinitionItem term={t({ message: 'Template', comment: 'Label for document template' })}>
            <Sidebar.Definition>
              <Chip size="small" appearance="secondary" icon={<Falcon icon="lock"/>} secondary={templateName}/>
            </Sidebar.Definition>
          </Sidebar.DefinitionItem>)}

        <Sidebar.DefinitionItem term={t({ message: 'Created at', comment: 'Label for document creation date' })}>
          <Sidebar.Definition>
            <Chip size="small" appearance="secondary" icon={<Falcon icon="lock"/>} secondary={createdAt}/>
          </Sidebar.Definition>
        </Sidebar.DefinitionItem>

        <Sidebar.DefinitionItem term={t({ message: 'Updated at', comment: 'Label for document last update date' })}>
          <Sidebar.Definition>
            <Chip size="small" appearance="secondary" icon={<Falcon icon="lock"/>} secondary={updatedAt}/>
          </Sidebar.Definition>
        </Sidebar.DefinitionItem>

        <Sidebar.DefinitionItem term={t({ message: 'Created by', comment: 'Label for document creator' })}>
          <Sidebar.Definition>
            <Chip size="small" appearance="secondary" icon={<Falcon icon="lock"/>} secondary={createdBy}/>
          </Sidebar.Definition>
        </Sidebar.DefinitionItem>

        <CompanyMetadataConfig>
          <TemplateCategory />
        </CompanyMetadataConfig>
      </Sidebar.DefinitionList>
    </Sidebar.Section>);
}
